import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        planningGroup: '=',
        courseVersions: '=',
        sites: '='
    },
    template: `
        <div class="well">
             <courses-courses-edit-occurrence-automated-planning-group-steps-general
                planning-group="vm.planningGroup"
                course-versions="vm.courseVersions"
                sites="vm.sites"
                context="'add'"
            />
        </div>
    `
})
export default class {
}



// WEBPACK FOOTER //
// ./src/app/components/courses/courses/edit/occurrence/automated/planningGroup/add/general/index.js